"use client"
import "./Committee.css"
import { FaHome, FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa"
import founderImg from "../assets/founder.jpg"
import generalSecretaryImg from "../assets/general-secretary.png"
import treasurerImg from "../assets/treasurer.jpg"
import chiefPatronImg from "../assets/chief-patron.png"
import socialMediaLeadImg from "../assets/social-media-lead.jpeg"
import organisingAndOutreachImg from "../assets/organising-and-outreach.jpeg"
import jointsec from "../assets/joint-secretary.jpeg"
import vicepresident from "../assets/vice-president.png"
import webPM from "../assets/website-and-project-manager.jpg"
function Committee() {
  const fittedImageMemberIds = [3, 6, 7, 8]

  const committeeMembers = [
    {
      id: 1,
      name: "K Narsi Reddy",
      position: "Hon' President",
      description: "Providing leadership and guidance for the foundation's long-term mission",
      image: chiefPatronImg,
      social: null,
    },
    {
      id: 2,
      name: "Dr. K. Mahesh",
      position: "Founder & President",
      description: "Leading the foundation with over 10 years of experience in social development",
      image: founderImg,
      social: {
        facebook: "https://facebook.com/",
        instagram: "https://instagram.com/",
        linkedin: "https://linkedin.com/",
      },
    },
    {
      id: 3,
      name: "Gavinolla Ram Reddy",
      position: "General Secretary",
      description: "Overseeing program implementation and strategic partnerships",
      image: generalSecretaryImg,
      social: null,
    },
    {
      id: 4,
      name: "Shiva Ramulu",
      position: "Vice President",
      description: "Supporting the president in strategic decision-making and organizational growth",
      image: vicepresident,
      social: null,
    },
    {
      id: 5,
      name: "Koram Shiva Raj",
      position: "Joint Secretary",
      description: "Assisting in organizational management and coordinating volunteer efforts",
      image: jointsec,
      social: null,
    },
    {
      id: 6,
      name: "K. Srinivas",
      position: "Treasurer",
      description: "Managing financial resources and ensuring transparency",
      image: treasurerImg,
      social: null,
    },
    {
      id: 7,
      name: "K. Harsha Vardhan",
      position: "Organising and Outreach Lead",
      description: "Coordinating events and strengthening grassroots community connections",
      image: organisingAndOutreachImg,
      social: null,
    },
    {
      id: 8,
      name: "G. SHIVANI",
      position: "Social Media",
      description: "Driving digital outreach and community engagement across social platforms",
      image: socialMediaLeadImg,
      social: null,
    },
    {
      id:9,
      name:" Sai Pranay Tadakamalla",
      position: "Website and Project Manager",
      description: "Responsible for developing and managing the website and Android application, while overseeing overall project planning, progress, and implementation.",
      image:webPM,
      social: null
    }
  ]

  return (
    <section id="committee" className="committee">
      <div className="container">
        <div className="section-header">
          <h2>Our Committee</h2>
          <div className="underline"></div>
        </div>

        <div className="committee-members">
          {committeeMembers.map((member) => (
            <div className="member-card" key={member.id}>
              <div className="image-wrapper">
                <img
                  src={member.image || "/placeholder.svg"}
                  alt={member.name}
                  className={`member-avatar ${fittedImageMemberIds.includes(member.id) ? "member-avatar--general-secretary" : ""}`}
                />
                {member.social && (
                  <div className="social-overlay">
                    {member.social.facebook && (
                      <a href={member.social.facebook} target="_blank" rel="noopener noreferrer">
                        <FaFacebookF />
                      </a>
                    )}
                    {member.social.instagram && (
                      <a href={member.social.instagram} target="_blank" rel="noopener noreferrer">
                        <FaInstagram />
                      </a>
                    )}
                    {member.social.linkedin && (
                      <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer">
                        <FaLinkedinIn />
                      </a>
                    )}
                  </div>
                )}
              </div>
              <div className="member-info">
                <h4>{member.name}</h4>
                <p className="member-position">{member.position}</p>
                <p className="member-desc">{member.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="committee-highlights">
          <div className="highlight-section">
            <div className="highlight-header">
              <h3>Our Philosophy</h3>
              <div className="underline highlight-underline"></div>
            </div>
            <div className="philosophy-content">
              <div className="philosophy-quote">
                <blockquote>"Service for a better society."</blockquote>
              </div>
              <p className="philosophy-text">
                We believe that positive change begins with small actions. By empowering individuals and communities
                with the right tools and support, we can create a ripple effect that leads to significant
                transformation. Our work is guided by principles of inclusivity, sustainability, and community
                participation.
              </p>
              <p className="philosophy-text">
                The Pramila Foundation continues to grow and expand its reach to more communities in need. Our dedicated
                team of staff and volunteers work tirelessly to implement programs that create meaningful change in
                people's lives. We believe that by working together, we can build a more equitable and sustainable
                future for all.
              </p>
            </div>
          </div>
        </div>

        <div className="home-button-container">
          <button className="home-button" onClick={() => (window.location.href = "/")}>
            <FaHome className="button-icon" /> Back to Home
          </button>
        </div>
      </div>
    </section>
  )
}

export default Committee
